export interface CopyToClipboardOptions {
  onSuccess?: () => void;
  onError?: () => void;
}

/**
 * Copies `text` to the clipboard using a temporary offscreen textarea and
 * `document.execCommand('copy')`. Callers supply `onSuccess`/`onError` to
 * surface their own (typically localized) feedback for the result.
 */
export function copyToClipboard(text: string, options?: CopyToClipboardOptions): void {
  const input = document.createElement('textarea');
  input.value = text;
  document.body.appendChild(input);
  input.select();
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      options?.onSuccess?.();
    } else {
      options?.onError?.();
    }
  } catch (err) {
    options?.onError?.();
  } finally {
    document.body.removeChild(input);
  }
}
